// src/redux/Service/productsApi.js
import { api } from "./api";

export const productsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getProducts: builder.query({
      query: () => "api/Stock/Products",
      providesTags: ["products"],
    }),
    addProduct: builder.mutation({
      query: (formData) => ({
        url: "api/Stock/Products",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["products"],
    }),
    editProduct: builder.mutation({
      query: (formData) => ({
        url: "api/Stock/Products",
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: ["products"],
    }),
    deleteProduct: builder.mutation({
      query: (productId) => ({
        url: `api/Stock/Products?ProductID=${productId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["products"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetProductsQuery,
  useAddProductMutation,
  useEditProductMutation,
  useDeleteProductMutation,
} = productsApi;
